<script>
  import { format, isValid, parse } from "date-fns"
  import Vue from "vue"
  import { TheMask } from "vue-the-mask"
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import Icon from "@/core/components/Icon"
  import SearchSelect from "@/core/components/SearchSelect"
  import Select from "@/core/components/Select"
  import { mask } from "@/core/services/helpers"
  import { getAddressByCep } from "../getAddressByCep"
  import { applyDateMask, isValidDateInput } from "../helper"
  import ContactsList from "./components/ContactsList.vue"
  import EstagiarioForm from "./components/EstagiarioForm.vue"
  import EstudanteForm from "./components/EstudanteForm.vue"
  import TrabalhadorForm from "./components/TrabalhadorForm.vue"
  import { TipoBeneficiario } from "./StepOne.vue"

  const BASE64_REGEX = /:(.*?);/
  export default {
    components: {
      Breadcrumbs,
      TheMask,
      Select,
      Icon,
      EstudanteForm,
      ContactsList,
      TrabalhadorForm,
      EstagiarioForm,
      "search-select": SearchSelect,
    },
    data: () => {
      return {
        obs: "",
        obs_form: "",
        obs_pendencia: null,
        filiacaoOptions: [
          { id: 1, name: "MÃE" },
          { id: 2, name: "PAI" },
          { id: 3, name: "TIO" },
          { id: 4, name: "RESPONSÁVEL" },
        ],
        TipoBeneficiario,
        tiposBeneficiario: [
          {
            name: "Estudante",
            id: TipoBeneficiario.ESTUDANTE.toString(),
          },
          {
            name: "Estagiário",
            id: TipoBeneficiario.ESTAGIARIO.toString(),
          },
          {
            name: "Trabalhador",
            id: TipoBeneficiario.TRABALHADOR.toString(),
          },
        ],
        tipoCursos: [
          { name: "Fundamental", id: 1 },
          { name: "Médio", id: 2 },
          { name: "Superior", id: 3 },
          { name: "Especialização", id: 4 },
          { name: "Técnico", id: 5 },
        ],
        title: "SPL Navegantes",
        crumbs: [
          { name: "Início", path: "index" },
          { name: "SPL Navegantes", path: "spl-navegantes.show" },
          { name: "Editar", path: "spl-navegantes.index" },
        ],
        alerts: ["Consulte a equipe técnica em caso de dúvida ou correção."],
        id: 0,
        getBeneficiarioLoading: true,
        getContatoLoading: true,
        situations: [
          { id: 1, label: "INICIADO", color: "#DC904A" },
          { id: 2, label: "ANALISADO", color: "#028C4A" },
          { id: 3, label: "ATIVO", color: "#028C4A" },
          { id: 4, label: "VENCIDO", color: "#DA3E3E" },
          { id: 5, label: "PENDENTE", color: "#DC904A" },
          { id: 6, label: "CANCELADO", color: "#DA3E3E" },
          { id: 7, label: "A VENCER", color: "#DA3E3E" },
        ],
        beneficiario: {
          idbeneficiario: null,
          nuusuario: "",
          nmnome: "",
          dtnascimento: "",
          idsituacao: "",
          document: "",
          numunicipio: "",
          tppasse: "",
          fljornada: "",
          filiacao: [
            {
              idfiliacao: "",
              document: "",
              street: "",
              number: "",
              district: "",
              city_id: "",
              cep: "",
            },
          ],
          contatos: [
            {
              emails: [],
              phones: [],
            },
          ],
          contato_filiacao: {
            email: [""],
            telefone: [""],
          },
          tpbeneficiario: 0,
          tpbeneficiario_inicial: 0,
          controle_registro: [],
          imagem: null,
        },
        enderecoInstituicao: {
          cep: "",
          street: "",
          number: "",
          district: "",
          complement: "",
          numunicipio: {
            name: "",
            state: {
              name: "",
            },
          },
        },
        enderecoInstituicaoForm: null,
        contatosBeneficiarioForm: [
          {
            emails: [],
            phones: [],
          },
        ],
        contatosInsituicao: {
          emails: [
            {
              contact: "",
              id: "",
            },
          ],
          phones: [
            {
              contact: "",
              id: "",
            },
          ],
        },
        contatosInsituicaoForm: [
          {
            emails: [],
            phones: [],
          },
        ],
        contatosFiliacaoForm: {
          emails: [
            {
              contact: "",
              id: "",
            },
          ],
          phones: [
            {
              contact: "",
              id: "",
            },
          ],
        },
        filiacaoMunicipio: "",
        beneficiarioEstudante: {
          nminstituicao: "",
          document: "",
          cep: "",
          street: "",
          number: "",
          district: "",
          municipio: "",
        },
        beneficiarioEstudanteForm: {
          nminstituicao: "",
          document: "",
          cep: "",
          street: "",
          number: "",
          district: "",
          municipio: "",
        },
        beneficiarioTrabalhador: {
          nminstituicao: "",
          document: "",
          cep: "",
          street: "",
          number: "",
          district: "",
          municipio: {
            name: "",
            state: {
              name: "",
            },
          },
        },
        beneficiarioTrabalhadorForm: {
          nminstituicao: "",
          document: "",
          cep: "",
          street: "",
          number: "",
          district: "",
          municipio: {
            name: "",
            state: {
              name: "",
            },
          },
          isValidAdmissionDate: true,
        },
        beneficiarioEstagiario: {
          nminstituicao: "",
          document: "",
          cep: "",
          street: "",
          number: "",
          district: "",
          municipio: "",
        },
        beneficiarioEstagiarioForm: {
          nminstituicao: "",
          document: "",
          cep: "",
          street: "",
          number: "",
          district: "",
          municipio: "",
          isValidAdmissionDate: true,
          isValidClosureDate: true,
        },
        //status de edição
        isBeneficiarioEdit: false,
        isObservacaoEdit: false,
        isContatoEdit: false,
        isFiliacaoEdit: [false],
        isFiliacaoContatoEdit: false,
        isTrabalhadorOuEstudanteEdit: false,
        isContatoInstituicaoEdit: false,
        //
        beneficiarioForm: null,
        hasErrors: false,
        hasEstudanteErrors: false,
        hasTrabalhadorErrors: false,
        hasEstagiarioErrors: false,
        hasFiliacaoErrors: false,
        hasAdditionalConditions: false,
        obs_id: "",
        observacao: "",
        observacao_pendencia: "",
        ispendencia: false,
        mostrarPopupPendencia: false,
        modalEntregaDocumentosData: {
          title: null,
          action: null,
        },
        validBirthDate: true,
        imagePreview: null,
        imageBeforeEdit: null,
      }
    },
    mounted() {
      this.id = this.$route.params.id
      this.getBeneficiario()
      document.title = `${this.title} - ${process.env.VUE_APP_TITLE}`
    },
    methods: {
      format,
      mask,
      ordenarFiliacaoPorCpfNaoNulo(filiacao) {
        let filiacaoOrdenada = filiacao.sort((a, b) => {
          if (a.document !== "" && !b.document) {
            return -1
          }
          if (!a.document && b.document !== "") {
            return 1
          }
          return 0
        })
        return filiacaoOrdenada
      },
      mapEstudante(data) {
        const inst = data.instituicao

        this.beneficiarioEstudante = {
          ...data.estudante,
          nminstituicao: inst?.name || "",
          document: inst?.document || "",
          cep: inst?.cep || "",
          street: inst?.street || "",
          number: inst?.number || "",
          district: inst?.district || "",
          complement: inst?.complement || "",
          municipio: inst?.city || "",
        }

        this.beneficiarioEstudanteForm = {
          ...this.beneficiarioEstudante,
        }
      },

      mapTrabalhador(data) {
        const inst = data.instituicao
        const trabalhador = data.trabalhador || {}

        this.beneficiarioTrabalhador = {
          ...trabalhador,
          nminstituicao: inst?.name || "",
          document: inst?.document || "",
          cep: inst?.cep || "",
          street: inst?.street || "",
          number: inst?.number || "",
          district: inst?.district || "",
          complement: inst?.complement || "",
          municipio: inst?.city || {
            name: "",
            state: { name: "" },
          },
          dtadmissao: trabalhador.dtadmissao
            ? format(new Date(trabalhador.dtadmissao), "dd/MM/yyyy")
            : "",
          vlsalario: trabalhador.vlsalario ?? 0,
        }

        this.beneficiarioTrabalhadorForm = {
          ...this.beneficiarioTrabalhador,
          isValidAdmissionDate: true,
        }
      },

      mapEstagiario(data) {
        const inst = data.instituicao
        const estagiario = data.estagiario || {}

        this.beneficiarioEstagiario = {
          ...estagiario,
          nminstituicao: inst?.name || "",
          document: inst?.document || "",
          cep: inst?.cep || "",
          street: inst?.street || "",
          number: inst?.number || "",
          district: inst?.district || "",
          complement: inst?.complement || "",
          municipio: inst?.city || "",
          dtadmissao: estagiario.dtadmissao
            ? format(new Date(estagiario.dtadmissao), "dd/MM/yyyy")
            : "",
          dtencerramento: estagiario.dtencerramento
            ? format(new Date(estagiario.dtencerramento), "dd/MM/yyyy")
            : "",
        }

        this.beneficiarioEstagiarioForm = {
          ...this.beneficiarioEstagiario,
          isValidAdmissionDate: true,
          isValidClosureDate: true,
        }
      },
      mapContacts(emails = [], phones = []) {
        return {
          emails: emails.length
            ? emails.map(({ contact, id }) => ({ contact, id }))
            : [{ contact: "", id: "" }],
          phones: phones.length
            ? phones.map(({ contact, id }) => ({ contact, id }))
            : [{ contact: "", id: "" }],
        }
      },

      emptyMunicipio() {
        return {
          id: "",
          name: "",
          ibge_code: "",
          state: {
            id: "",
            name: "",
            initials: "",
          },
        }
      },
      mapObservacoes(data) {
        this.obs = data.observacao?.deobservacao || ""
        this.obs_form = this.obs
        this.obs_id = data.observacao?.idobservacao || ""
        this.obs_pendencia = data.observacao_pendencia?.deobservacao || ""
      },
      mapBeneficiarioBase(data) {
        const { usuario } = data

        this.beneficiario = {
          ...this.beneficiario,
          idbeneficiario: data.idbeneficiario,
          nmnome: data.nmnome,
          document: usuario.document_formatted,
          cep: usuario.cep,
          street: usuario.street,
          number: usuario.number,
          complement: usuario.complement,
          district: usuario.district,
          numunicipio: usuario.city,
          tplocomocao: data.tplocomocao,
          fljornada: data.fljornada,
          dtcadastro: data.dtcadastro,
          nuusuario: data.nuusuario,
          tpbeneficiario: data.tpbeneficiario,
          tpbeneficiario_inicial: data.tpbeneficiario,
          dtnascimento: format(new Date(data.dtnascimento), "dd/MM/yyyy"),
          contatos: this.mapContacts(usuario.emails, usuario.phones),
          imagem: data.imagem,
          doacao: data.doacao,
        }

        if (data.controle_registro?.length) {
          this.beneficiario.idsituacao = data.controle_registro[0].idsituacao
          this.beneficiario.controle_registro = data.controle_registro[0]
        }

        this.beneficiarioForm = JSON.parse(JSON.stringify(this.beneficiario))
      },
      mapFiliacao(data) {
        const ensureContatos = (f = {}) => ({
          emails: f.emails?.length
            ? f.emails.map(({ contact, id }) => ({ contact, id }))
            : [{ contact: "", id: "" }],
          phones: f.phones?.length
            ? f.phones.map(({ contact, id }) => ({ contact, id }))
            : [{ contact: "", id: "" }],
        })

        if (!data.filiacao?.length) {
          this.beneficiario.filiacao = [
            {
              idfiliacao: "",
              document: "",
              street: "",
              number: "",
              district: "",
              city_id: "",
              cep: "",
              contatos: ensureContatos(),
            },
          ]
          return
        }

        const ordenada = this.ordenarFiliacaoPorCpfNaoNulo(data.filiacao)

        this.beneficiario.filiacao = ordenada.map((f) => ({
          street: "",
          cep: "",
          document: "",
          ...f,
          contatos: ensureContatos(f),
        }))

        this.filiacaoMunicipio = data.filiacao[0].city ?? ""
      },

      mapInstituicao(data) {
        if (!data.instituicao) {
          return
        }

        const inst = data.instituicao

        this.contatosInsituicao = this.mapContacts(inst.emails, inst.phones)
        this.contatosInsituicaoForm = this.mapContacts(inst.emails, inst.phones)

        Object.assign(this.enderecoInstituicao, {
          cep: inst.cep,
          complement: inst.complement,
          district: inst.district,
          number: inst.number,
          street: inst.street,
          numunicipio: inst.city,
        })
      },
      getInstituicaoBase(data) {
        return {
          document: data.instituicao?.document || "",
          nminstituicao: data.instituicao?.name || "",
        }
      },
      mapBeneficiarioByTipo(data) {
        if (!Number(this.beneficiario.tpbeneficiario)) {
          return
        }

        switch (Number(this.beneficiario.tpbeneficiario)) {
          case TipoBeneficiario.ESTUDANTE:
            this.mapEstudante(data)
            break
          case TipoBeneficiario.TRABALHADOR:
            this.mapTrabalhador(data)
            break
          case TipoBeneficiario.ESTAGIARIO:
            this.mapEstagiario(data)
            break
          default:
            break
        }
      },

      base64ToFile(base64, filename) {
        if (!base64) {
          return null
        }
        const arr = base64.split(",")
        const mime = arr[0].match(BASE64_REGEX)[1]
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)

        for (let i = 0; i < bstr.length; i++) {
          u8arr[i] = bstr.charCodeAt(i)
        }

        return new File([u8arr], filename, { type: mime })
      },
      handleImage(event) {
        const file = event.target.files[0]
        if (!file) {
          return
        }

        this.beneficiario.imagem = file

        this.previewImage(file)
      },
      previewImage(file) {
        if (file) {
          this.imagePreview = URL.createObjectURL(file)
        } else {
          this.imagePreview = null
        }
      },

      async getBeneficiario() {
        this.$Progress.start()
        this.getBeneficiarioLoading = true

        try {
          const { data } = await this.$axios.get(
            `/api/spl-navegantes/beneficiarios/dados/${this.id}`
          )

          data.imagem = this.base64ToFile(data.foto_base64, "avatar")

          this.mapObservacoes(data)
          this.mapFiliacao(data)
          this.mapBeneficiarioBase(data)
          this.mapInstituicao(data)

          if (data.doacao?.length) {
            this.beneficiario.tppasse = data.doacao.at(-1).tppasse
          }

          this.mapBeneficiarioByTipo(data)
          sessionStorage.setItem(
            "beneficiarioEdit",
            JSON.stringify(this.beneficiario)
          )
          sessionStorage.setItem(
            "beneficiarioInstituicao",
            JSON.stringify(this.getInstituicaoBase(data))
          )
          sessionStorage.setItem("obs", this.obs)
          if (this.beneficiario.imagem) {
            this.previewImage(this.beneficiario.imagem)
          }
        } catch (e) {
          this.$toast.error({
            message:
              e.response?.data?.message ||
              e.response?.data?.error ||
              "Erro desconhecido",
          })
        } finally {
          this.getBeneficiarioLoading = false
          this.$Progress.finish()
        }
      },

      onCpfChangeFiliacao(index, cpf) {
        this.beneficiarioForm.filiacao[index].document = cpf
        this.isFormValid()
      },
      async onCepChangeFiliacao(index) {
        if (this.beneficiarioForm.filiacao[index].cep.length === 8) {
          this.$Progress.start()
          const { logradouro, bairro, localidade, uf, ibge } =
            await getAddressByCep(this.beneficiarioForm.filiacao[index].cep)
          if (logradouro) {
            this.beneficiarioForm.filiacao[index].street = logradouro
            this.beneficiarioForm.filiacao[index].district = bairro
            this.beneficiarioForm.filiacao[index].city = {
              id: "",
              name: localidade,
              ibge_code: ibge,
              state: {
                id: "",
                name: uf,
                initials: uf,
              },
            }
            this.isFormValid()
          } else {
            this.$toast.error({
              message: "CEP Inválido.",
            })
          }
          this.$Progress.finish()
        }
      },
      async onCepChangeBeneficiario(cep) {
        if (cep.length === 8) {
          this.$Progress.start()
          const { logradouro, bairro, localidade, uf, ibge } =
            await getAddressByCep(cep)
          if (logradouro) {
            this.beneficiarioForm.street = logradouro
            this.beneficiarioForm.district = bairro
            this.beneficiarioForm.numunicipio = {
              id: "",
              name: localidade,
              ibge_code: ibge,
              state: {
                id: "",
                name: uf,
                initials: uf,
              },
            }
          } else {
            this.$toast.error({
              message: "CEP Inválido.",
            })
          }
          this.$Progress.finish()
        }
      },
      async postDisablePending() {
        try {
          await this.$axios.put(
            `/api/spl-navegantes/beneficiarios/remover/pendencia/${this.id}`
          )

          sessionStorage.clear()
          this.$toast.success({
            title: "OK",
            message: "Pendências removidas com sucesso",
          })
        } catch (error) {
          this.$toast.error({
            message: "Error",
          })
        }
      },
      getParentesco(tpparentesco) {
        if (tpparentesco) {
          return this.filiacaoOptions.find(
            (item) => Number(item.id) === Number(tpparentesco)
          ).name
        }
      },
      getCityStateNameByCode(code) {
        const ValidCityCodes = {
          NAVEGANTES: 4583,
          ITAJAI: 4540,
        }
        if (code === ValidCityCodes.ITAJAI) {
          return "Itajaí / SC"
        }
        if (code === ValidCityCodes.NAVEGANTES) {
          return "Navegantes / SC"
        }
        return "-"
      },
      async handleEditBeneficiario() {
        this.$Progress.start()
        const body = await this.getEditBody()
        try {
          await this.$axios.put(
            `/api/spl-navegantes/beneficiarios/editar/${this.id}`,
            body
          )
          this.$toast.success({
            title: "OK",
            message: "Dados editados com sucesso",
          })
          this.$router.go(0)
          //this.$router.push({ name: "spl-navegantes.show" });
        } catch (e) {
          if (e.response) {
            this.$toast.error({
              message: e.response?.data?.message || e.response?.data?.error,
            })
          } else {
            this.$toast.error({ message: "Erro desconhecido" })
          }
        } finally {
          this.$Progress.finish()
        }
      },
      fileToBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            // remove "data:image/png;base64," prefix
            const base64 = reader.result.split(",")[1]
            resolve(base64)
          }
          reader.onerror = reject
          reader.readAsDataURL(file)
        })
      },
      async getEditBody() {
        const buildUsuario = () => ({
          document: this.beneficiario.document,
          nmnome: this.beneficiarioForm.nmnome,
          cep: this.beneficiarioForm.cep,
          street: this.beneficiarioForm.street,
          number: this.beneficiarioForm.number,
          district: this.beneficiarioForm.district,
          complement: this.beneficiarioForm.complement,
          municipio: this.beneficiario.numunicipio,
          phones: this.contatosBeneficiarioForm.phones,
          emails: this.contatosBeneficiarioForm.emails,
        })

        const buildFiliacao = () =>
          this.beneficiarioForm.filiacao.map(
            (
              {
                idfiliacao,
                document,
                nmnome,
                tpparentesco,
                cep,
                number,
                street,
                district,
                complement,
                city: municipio,
              },
              index
            ) => ({
              idfiliacao,
              document,
              nmnome,
              tpparentesco,
              cep,
              number,
              district,
              street,
              complement,
              municipio,
              phones: this.beneficiarioForm.filiacao[index].contatos.phones,
              emails: this.beneficiarioForm.filiacao[index].contatos.emails,
            })
          )

        const buildInstituicao = (form) => ({
          nmnome: form.nminstituicao,
          document: form.document,
          tpinstituicao: 3,
          cep: form.cep,
          street: form.street,
          number: form.number,
          district: form.district,
          complement: form.complement,
          municipio: form.municipio,
          phones: this.contatosInsituicaoForm.phones,
          emails: this.contatosInsituicaoForm.emails,
        })

        let imagem = null

        if (this.beneficiario.imagem) {
          imagem = await this.fileToBase64(this.beneficiario.imagem)
        }

        const baseBody = {
          nmnome: this.beneficiarioForm.nmnome,
          dtnascimento: this.formatDate(this.beneficiarioForm.dtnascimento),
          tpbeneficiario: Number(this.beneficiario.tpbeneficiario),
          usuario: buildUsuario(),
          filiacao: buildFiliacao(),
          observacao: {
            idobservacao: this.obs_id,
            deobservacao: this.obs,
          },
          imagem,
        }

        switch (Number(this.beneficiario.tpbeneficiario)) {
          case TipoBeneficiario.ESTUDANTE:
            return {
              ...baseBody,
              instituicao: buildInstituicao(this.beneficiarioEstudanteForm),
              tpcurso: this.beneficiarioEstudanteForm.tpcurso,
              nuseriecurso: this.beneficiarioEstudanteForm.nuseriecurso,
              idcurso: this.beneficiarioEstudanteForm.curso.idcurso ?? "1",
            }

          case TipoBeneficiario.ESTAGIARIO:
            return {
              ...baseBody,
              instituicao: buildInstituicao(this.beneficiarioEstagiarioForm),
              dtadmissao: this.formatDate(
                this.beneficiarioEstagiarioForm.dtadmissao
              ),
              dtencerramento: this.formatDate(
                this.beneficiarioEstagiarioForm.dtencerramento
              ),
            }

          case TipoBeneficiario.TRABALHADOR:
            return {
              ...baseBody,
              instituicao: buildInstituicao(this.beneficiarioTrabalhadorForm),
              ispendencia: true,
              tplocomocao: 1,
              idprofissao:
                this.beneficiarioTrabalhadorForm.profissao.idprofissao,
              vlsalario: this.beneficiarioTrabalhadorForm.vlsalario,
              dtadmissao: this.formatDate(
                this.beneficiarioTrabalhadorForm.dtadmissao
              ),
            }

          default:
            return
        }
      },
      goBack() {
        this.$router.push({ name: "spl-navegantes.show" })
      },
      validateBeneficiarioCEP() {
        if (
          this.beneficiario.numunicipio.name !== "Itajaí" &&
          this.beneficiario.numunicipio.name !== "Navegantes"
        ) {
          this.$toast.error({
            title: "Erro",
            message:
              "CEP do beneficário inválido! Município deve ser Itajaí ou Navegantes",
          })
          return false
        }
        return true
      },
      saveBeneficiarioForm() {
        this.isFormValid()
        if (this.hasErrors || this.hasFiliacaoErrors) {
          this.$toast.error({
            title: "Erro",
            message: this.hasFiliacaoErrors
              ? "É necessário atualizar as informações de filiação!"
              : "Verifique os campos obrigatórios!",
          })
        } else {
          const isCepValid = this.validateBeneficiarioCEP()
          if (isCepValid) {
            this.handleEditBeneficiario()
          }
        }
      },
      formatDate(date) {
        const [day, month, year] = date.split("/")
        return `${year}-${month}-${day}`
      },
      validateBirthDateOnInput(value) {
        const originalValue = value.slice(0, -1)

        // 1️⃣ Structural validation (typing rules)
        if (!isValidDateInput(value)) {
          this.beneficiarioForm.dtnascimento = originalValue
          return
        }

        // 2️⃣ Apply mask
        const maskedValue = applyDateMask(value)
        this.beneficiarioForm.dtnascimento = maskedValue

        // 3️⃣ Not complete yet
        if (maskedValue.length !== 10) {
          this.validBirthDate = false
          return
        }

        // 4️⃣ Semantic validation (real date + age rule)
        const parsedDate = parse(maskedValue, "dd/MM/yyyy", new Date())

        this.validBirthDate =
          isValid(parsedDate) && this.checkAtLeast1YearOld(parsedDate)
      },
      checkMajority(parsedDate) {
        const today = new Date()
        let age = today.getFullYear() - parsedDate.getFullYear()
        const m = today.getMonth() - parsedDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < parsedDate.getDate())) {
          age -= 1
        }
        return age
      },
      checkAtLeast1YearOld(parsedDate) {
        const today = new Date()
        let age = today.getFullYear() - parsedDate.getFullYear()
        const m = today.getMonth() - parsedDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < parsedDate.getDate())) {
          age -= 1
        }
        return age >= 1
      },
      resetValidationState() {
        this.validBirthDate = true
        this.hasErrors = false
        this.hasFiliacaoErrors = false
        this.hasEstudanteErrors = false
        this.hasTrabalhadorErrors = false
        this.hasEstagiarioErrors = false
        this.additionalConditions = false
      },
      validateBirthDateAndAdditionalConditions() {
        const dtNasc = this.isBeneficiarioEdit
          ? this.beneficiarioForm.dtnascimento
          : this.beneficiario.dtnascimento

        if (dtNasc && dtNasc.length === 8) {
          this.validBirthDate = false
          return
        }

        if (!dtNasc || dtNasc.length !== 10) {
          return
        }

        const parsedDate = parse(dtNasc, "dd/MM/yyyy", new Date())

        if (!this.checkAtLeast1YearOld(parsedDate)) {
          this.validBirthDate = false
        }

        this.additionalConditions = this.checkMajority(parsedDate) < 18
      },
      getFiliacaoData(index) {
        const source = this.isFiliacaoEdit[index]
          ? this.beneficiarioForm.filiacao[index]
          : this.beneficiario.filiacao[index]

        return {
          document: source.document,
          cep: source.cep,
          nome: source.nmnome,
        }
      },
      updateAdditionalConditions(isSatisfied, { document, cep }) {
        if (!this.additionalConditions || isSatisfied) {
          return isSatisfied
        }

        return Boolean(document && cep)
      },
      hasFiliacaoError({ document, cep, nome }, additionalSatisfied) {
        return (
          (this.additionalConditions && !additionalSatisfied) ||
          this.isNullOrEmpty(nome) ||
          (this.isNullOrEmpty(document) && !this.isNullOrEmpty(cep)) ||
          (!this.isNullOrEmpty(document) && this.isNullOrEmpty(cep))
        )
      },
      markFiliacaoError() {
        this.hasFiliacaoErrors = true
        this.isFiliacaoEdit[0] = true
      },

      validateFiliacao() {
        let additionalSatisfied = !this.additionalConditions

        for (const index of this.beneficiarioForm.filiacao.keys()) {
          const filiacaoData = this.getFiliacaoData(index)

          additionalSatisfied = this.updateAdditionalConditions(
            additionalSatisfied,
            filiacaoData
          )

          if (this.hasFiliacaoError(filiacaoData, additionalSatisfied)) {
            this.markFiliacaoError()
            return
          }
        }
      },
      validateEstudante() {
        const {
          curso,
          nuseriecurso,
          tpcurso,
          nminstituicao,
          document: estudanteDocument,
        } = this.beneficiarioEstudanteForm

        const hasError =
          estudanteDocument === undefined ||
          nuseriecurso === undefined ||
          nminstituicao === undefined ||
          tpcurso === undefined ||
          (tpcurso > 2 && curso === undefined)

        this.hasEstudanteErrors = hasError
        this.beneficiarioEstudanteForm.hasErrors = hasError
      },
      validateTrabalhador() {
        const {
          profissao,
          dtadmissao,
          nminstituicao,
          document: trabalhadorDocument,
          vlsalario,
          isValidAdmissionDate,
        } = this.beneficiarioTrabalhadorForm

        const hasError =
          trabalhadorDocument === undefined ||
          dtadmissao === undefined ||
          profissao === undefined ||
          nminstituicao === undefined ||
          vlsalario === 0 ||
          !isValidAdmissionDate

        this.hasTrabalhadorErrors = hasError
        this.beneficiarioTrabalhadorForm.hasErrors = hasError
      },
      validateEstagiario() {
        const {
          dtencerramento,
          dtadmissao,
          nminstituicao,
          document: estagiarioDocument,
          isValidAdmissionDate,
          isValidClosureDate,
        } = this.beneficiarioEstagiarioForm

        const hasError =
          dtencerramento === undefined ||
          estagiarioDocument === undefined ||
          nminstituicao === undefined ||
          dtadmissao === undefined ||
          !isValidAdmissionDate ||
          !isValidClosureDate

        this.hasEstagiarioErrors = hasError
        this.beneficiarioEstagiarioForm.hasErrors = hasError
      },
      scrollToErrorsIfAny() {
        if (
          this.hasEstudanteErrors ||
          this.hasTrabalhadorErrors ||
          this.hasEstagiarioErrors
        ) {
          window.location.href = "#ac"
        }
      },
      setFormErrorState() {
        const {
          document: beneficiarioDocument,
          nmnome,
          dtnascimento,
          cep: beneficiarioCep,
          street,
          district,
        } = this.beneficiarioForm

        this.hasErrors =
          this.hasEstudanteErrors ||
          this.hasTrabalhadorErrors ||
          this.hasEstagiarioErrors ||
          this.hasFiliacaoErrors ||
          this.isNullOrEmpty(beneficiarioDocument) ||
          this.isNullOrEmpty(nmnome) ||
          this.isNullOrEmpty(beneficiarioCep) ||
          this.isNullOrEmpty(street) ||
          this.isNullOrEmpty(district) ||
          this.isNullOrEmpty(dtnascimento) ||
          !this.validBirthDate
      },

      validateBeneficiarioByTipo() {
        switch (Number(this.beneficiario.tpbeneficiario)) {
          case TipoBeneficiario.ESTUDANTE:
            this.validateEstudante()
            break
          case TipoBeneficiario.TRABALHADOR:
            this.validateTrabalhador()
            break
          case TipoBeneficiario.ESTAGIARIO:
            this.validateEstagiario()
            break
          default:
            this.hasFiliacaoErrors = true
        }
      },
      scrollToTipoErrorsIfAny() {
        if (
          this.hasEstudanteErrors ||
          this.hasTrabalhadorErrors ||
          this.hasEstagiarioErrors
        ) {
          window.location.href = "#ac"
        }
      },
      setFinalFormErrorState() {
        const { document, nmnome, dtnascimento, cep, street, district } =
          this.beneficiarioForm

        this.hasErrors =
          this.hasEstudanteErrors ||
          this.hasTrabalhadorErrors ||
          this.hasEstagiarioErrors ||
          this.hasFiliacaoErrors ||
          this.isNullOrEmpty(document) ||
          this.isNullOrEmpty(nmnome) ||
          this.isNullOrEmpty(cep) ||
          this.isNullOrEmpty(street) ||
          this.isNullOrEmpty(district) ||
          this.isNullOrEmpty(dtnascimento) ||
          !this.validBirthDate
      },

      isFormValid() {
        this.resetValidationState()

        this.validateBirthDateAndAdditionalConditions()
        this.validateFiliacao()
        this.validateBeneficiarioByTipo()

        this.scrollToTipoErrorsIfAny()
        this.setFinalFormErrorState()
      },

      isNullOrEmpty(value) {
        return value === null || value === ""
      },
      onEditBeneficiarioFiliacaoClick(index) {
        if (
          this.beneficiarioForm.filiacao[index].document !== "" &&
          this.beneficiarioForm.filiacao[index].cep !== ""
        ) {
          this.isFiliacaoContatoEdit = true
        } else {
          this.$toast.error({
            message: "Os campos CPF e CEP da filiação são obrigatórios.",
          })
        }
      },
      onEditBeneficiarioClick(secaoEdit, index) {
        // this.beneficiarioForm = JSON.parse(
        //     JSON.stringify(this.beneficiario)
        // );
        //this.contatosInsituicaoForm = JSON.parse(
        //    JSON.stringify(this.contatosInsituicao)
        //);
        // this.contatosFiliacaoForm = JSON.parse(
        //     JSON.stringify(
        //         this.beneficiario.filiacao.map(
        //             filiacao => filiacao.contatos
        //         )
        //     )
        // );
        this.enderecoInstituicaoForm = { ...this.enderecoInstituicao }
        this.contatosBeneficiarioForm = JSON.parse(
          JSON.stringify(this.beneficiario.contatos)
        )

        switch (secaoEdit) {
          case "contatos":
            this.isContatoEdit = true
            break
          case "filiacao":
            this.isFiliacaoEdit[index] = true
            break
          case "filiacaoContato":
            this.isFiliacaoContatoEdit = true
            break
          case "trabalhadorOuEstudante":
            this.isTrabalhadorOuEstudanteEdit = true
            break
          case "contatoInstituicaoEdit":
            this.isContatoInstituicaoEdit = true
            break
          case "observacaoEdit":
            this.isObservacaoEdit = true
            break
          default:
            this.isBeneficiarioEdit = true
        }

        if (this.isBeneficiarioEdit) {
          this.imageBeforeEdit = this.beneficiario.imagem
        }
        // switch (Number(this.beneficiario.tpbeneficiario)) {
        //     case TipoBeneficiario.ESTUDANTE:
        //         this.beneficiarioEstudanteForm = {
        //             ...this.beneficiarioEstudante
        //         };
        //         break;
        //     case TipoBeneficiario.TRABALHADOR:
        //         this.beneficiarioTrabalhadorForm = {
        //             ...this.beneficiarioTrabalhador
        //         };
        //         break;
        //     case TipoBeneficiario.ESTAGIARIO:
        //         this.beneficiarioEstagiarioForm = {
        //             ...this.beneficiarioEstagiario
        //         };
        //         break;
        // }
      },
      cancelEditBeneficiario() {
        this.obs = this.obs_form
        if (
          this.beneficiario.tpbeneficiario.toString() !==
          this.beneficiarioForm.tpbeneficiario_inicial
        ) {
          this.beneficiario.tpbeneficiario =
            this.beneficiarioForm.tpbeneficiario_inicial
        }
        this.isTrabalhadorOuEstudanteEdit = false
        this.isBeneficiarioEdit = false
        this.isObservacaoEdit = false
        this.previewImage(this.imageBeforeEdit)
      },
      cancelEditContato() {
        this.isContatoEdit = false
      },
      cancelEditFiliacao(index) {
        Vue.set(this.isFiliacaoEdit, index, false)
      },
      cancelEditFiliacaoContato() {
        this.isFiliacaoContatoEdit = false
      },
      cancelEditTrabalhadorOuEstudante() {
        this.isTrabalhadorOuEstudanteEdit = false
      },
      cancelEditContatoInstituicao() {
        this.isContatoInstituicaoEdit = false
      },
      getSituation(situationId) {
        if (situationId) {
          return this.situations.find((item) => item.id === situationId)
        }
      },
      getTpCurso(tpcurso) {
        if (tpcurso) {
          return this.tipoCursos.find(
            (item) => Number(item.id) === Number(tpcurso)
          )
        }
      },
      getBeneficiarioType(type) {
        if (type) {
          switch (Number(type)) {
            case TipoBeneficiario.ESTAGIARIO:
              return "Estagiário"
            case TipoBeneficiario.ESTUDANTE:
              return "Estudante"
            case TipoBeneficiario.TRABALHADOR:
              return "Trabalhador"
            default:
              return "Trabalhador"
          }
        }
        return "-"
      },
      toggleObsPopup() {
        this.mostrarPopupPendencia = !this.mostrarPopupPendencia
      },
      editObs() {
        this.mostrarPopupPendencia = false
        this.isBeneficiarioEdit = true
        this.postDisablePending()
        this.beneficiario.idsituacao = 2
        this.$router.go(0)
      },
      abrirEntregaPasses() {
        if (this.beneficiarioForm.tpbeneficiario === "0") {
          this.$toast.error({
            message: "Necessário informar o tipo de beneficiário.",
          })
          return false
        }
        if (this.beneficiarioForm.controle_registro.length === 0) {
          this.$toast.error({
            message: "Necessário realizar a entrega de documentos.",
          })
          return false
        }

        const { idsituacao } = this.beneficiario
        const params = {
          id: this.id,
          screenType: "passes",
        }

        switch (idsituacao) {
          case 1:
          case 2:
            {
              this.$router.push({
                name: "spl-navegantes.documents",
                params,
              })
            }
            break
          case 5:
            {
              this.modalEntregaDocumentosData.title =
                "Existe alguma pendência no registro desse beneficiário, verifique qual é a partir do quadro acima"
              this.$refs.modalEntregaDocumentos.showModal()
            }
            break
          case 4:
            {
              this.modalEntregaDocumentosData.title =
                "O registro do beneficiário está vencido, você precisa solicitar toda a documentação para atualizar o cadastro"
              this.$refs.modalEntregaDocumentos.showModal()
            }
            break
          case 6:
            {
              this.modalEntregaDocumentosData.title =
                "O registro deste beneficiário está cancelado, ele não poderá mais receber o benefício"
              this.$refs.modalEntregaDocumentos.showModal()
            }
            break
          case 7:
            {
              this.$router.push({
                name: "spl-navegantes.documents",
                params,
              })
            }
            break
          case 3:
            {
              this.$router.push({
                name: "spl-navegantes.documents",
                params,
              })
            }
            break
          default:
            break
        }
      },
      abrirEntregaDocumentos() {
        if (this.beneficiarioForm.tpbeneficiario === "0") {
          this.$toast.error({
            message: "Necessário informar o tipo de beneficiário.",
          })
          return false
        }
        const { idsituacao } = this.beneficiario
        const params = {
          id: this.id,
          screenType: "document",
        }

        switch (idsituacao) {
          case 1:
            {
              this.modalEntregaDocumentosData.title =
                "O cadastro deste beneficiário ainda não foi concluído, favor finalizar o cadastro"
              this.$refs.modalEntregaDocumentos.showModal()
            }
            break
          case 2:
          case 3:
            {
              const dtexpiracao = new Date(
                this.beneficiario.controle_registro.dtexpiracao
              )
              const dtnow = new Date()
              const intervalo = dtexpiracao - dtnow
              const intervaloDias = Math.ceil(intervalo / (1000 * 60 * 60 * 24))

              if (intervaloDias < 31) {
                this.$router.push({
                  name: "spl-navegantes.documents",
                  params,
                })
              } else {
                this.modalEntregaDocumentosData.title =
                  "O registro deste beneficiário não está para vencer, você deseja atualizar o registro?"
                this.modalEntregaDocumentosData.action = "ABRIR_DOCUMENTOS"
                this.$refs.modalEntregaDocumentos.showModal()
              }
            }
            break
          case 5:
            {
              this.modalEntregaDocumentosData.title =
                "Existe alguma pendência no registro desse beneficiário, verifique qual é a partir do quadro acima"
              this.$refs.modalEntregaDocumentos.showModal()
            }
            break
          case 8:
            {
              this.$router.push({
                name: "spl-navegantes.documents",
                params,
              })
            }
            break
          case 6:
            {
              this.modalEntregaDocumentosData.title =
                "O registro deste beneficiário está cancelado, ele não poderá mais receber o benefício"
              this.$refs.modalEntregaDocumentos.showModal()
            }
            break
          // case 7:
          //     {
          //         this.modalEntregaDocumentosData.title =
          //             "O cadastro deste beneficiário ainda não foi concluído, favor finalizar o cadastro";
          //         this.$refs.modalEntregaDocumentos.showModal();
          //     }
          //     break;
          default: {
            this.$router.push({
              name: "spl-navegantes.documents",
              params,
            })
          }
        }
      },
      abrirHistoricoPasses() {
        this.$router.push({
          name: "spl-navegantes.historic-passes",
          params: { id: this.id },
        })
      },
      onModalEntregaDocumentosClose() {
        const action = this.modalEntregaDocumentosData.action

        if (action === "ABRIR_DOCUMENTOS") {
          this.$router.push({
            name: "spl-navegantes.documents",
            params: { id: this.id },
          })
        }
      },
      cityBeneficiarioSelected(city) {
        this.beneficiario.numunicipio = city
      },
      cityFiliacaoSelected(city) {
        this.beneficiarioForm.filiacao[0].city_id = city
      },
      tipoBeneficiariosSelected() {
        //if(beneficiario.tpbeneficiario)
        this.isTrabalhadorOuEstudanteEdit = true
      },
    },
    setValidAdmissionDate(value) {
      this.isValidAdmissionDate = value
    },
  }
</script>

<template>
  <div class="w-full bg-white">
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-8" :crumbs="crumbs"/>

      <div v-if="obs_pendencia" class="relative">
        <div
          v-if="mostrarPopupPendencia"
          class="content-pendencia expandido mb-2 text-uppercase p-2 absolute shadow-lg"
        >
          <div class="title flex flex-row justify-between items-center">
            <span
              class="flex flex-row items-center text-base uppercase text-red-600 font-bold"
            >
              <Icon icon="exclamation" class="h-4 mr-1 fill-current"/>
              Informação de pendência
            </span>
          </div>
          <div class="p-4">
            <span class="text-base uppercase font-bold">
              {{ obs_pendencia }}
            </span>
          </div>
          <div class="flex flex-row justify-between items-end">
            <div class="px-4">
              <span class="text-base text-gray-800 text-uppercase">
                Você deseja retirar essa pendência?
              </span>
              <div class="flex flex-row justify-start">
                <button
                  type="button"
                  class="flex items-center justify-center form-submit md:w-auto px-8"
                  @click="toggleObsPopup"
                  style="background: #e2e8f0;color: #028C4A"
                >
                  Não
                </button>
                <button
                  type="button"
                  @click="editObs"
                  class="ml-2 flex items-center justify-center form-submit md:w-auto px-8"
                >
                  Sim
                </button>
              </div>
            </div>
            <span @click="toggleObsPopup">
              <Icon
                icon="arrowUp"
                class="cursor-pointer h-4 mr-1 fill-current"
              />
            </span>
          </div>
        </div>
      </div>

      <div
        class="bg-gray-light lg:max-w-full my-4"
        :class="{ 'blur-content': mostrarPopupPendencia }"
      >
        <div
          class="flex justify-between w-full mb-8 border-b-2 border-green-base bg-white shadow-lg"
        >
          <span class="mt-2 text-base uppercase text-green-base">
            Controle de Registro
          </span>
          <button
            v-if="!getBeneficiarioLoading && !isObservacaoEdit"
            @click="onEditBeneficiarioClick('observacaoEdit')"
            class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-base"
          >
            <div class="flex text-green-base items-center justify-center">
              Editar
            </div>
          </button>
          <div
            v-if="!getBeneficiarioLoading && isObservacaoEdit"
            class="flex gap-3"
          >
            <button
              @click="cancelEditBeneficiario"
              class="px-2 py-2 mb-2 form-new-green sm:py-1 border-red-400"
            >
              <div class="flex text-red-400 items-center justify-center">
                Cancelar
              </div>
            </button>
            <button
              @click.prevent="$refs.modal.showModal()"
              class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-500"
            >
              <div class="flex text-green-500 items-center justify-center">
                Salvar
              </div>
            </button>
          </div>
        </div>
        <template v-if="getBeneficiarioLoading">
          <div class="px-4">Carregando...</div>
        </template>
        <template v-else>
          <div class="grid gap-5 grid-cols-1 md:grid-cols-12 px-3 pb-6">
            <div class="col-span-2">
              <span class="text-sm form-label text-gray-dark">
                DT. Expiração
              </span>
              <div class="text-red-500">
                {{
                  beneficiario.controle_registro.length != 0
                  ? format(new Date(beneficiario.controle_registro.dtexpiracao),"dd/MM/yyyy")
                  : "-"
                }}
              </div>
            </div>

            <div class="col-span-2">
              <span class="text-sm form-label text-gray-dark"> Situação </span>
              <div style="display: flex; justify-content: space-between;">
                <div
                  :style="{
                    color: beneficiario.idsituacao
                      ? getSituation(beneficiario.idsituacao).color
                      : ''
                  }"
                >
                  {{
                    beneficiario.controle_registro.length != 0
                    ? getSituation(beneficiario.controle_registro.idsituacao).label
                    : "-"
                  }}
                </div>
                <div
                  v-if="beneficiario.idsituacao == 5"
                  class="text-red-500 cursor-pointer"
                  style=" float: left; width: 50%; padding: 5px;"
                  @click="toggleObsPopup"
                >
                  <Icon icon="exclamation" class="h-4 mr-1 fill-current"/>
                </div>
              </div>
            </div>

            <div class="col-span-7">
              <span class="text-sm form-label text-gray-dark">
                Observação
              </span>
              <div class="w-full" v-if="isObservacaoEdit">
                <textarea
                  v-model="obs"
                  maxlength="255"
                  class="py-2 rounded form-input"
                  row="5"
                  style="max-height: 80px; min-height: 80px;"
                  placeholder="Escreva aqui sua observação"
                ></textarea>
              </div>
              <div v-else>
                <span class="text-sm form-label text-gray-dark">
                  {{ beneficiario.controle_registro.length != 0 ? obs : "-" }}
                </span>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-row justify-start items-center">
                Opções

                <button
                  @click="abrirEntregaDocumentos()"
                  class="flex items-center justify-center form-submit py-2 ml-3 md:w-auto"
                  style="background: #e2e8f0; border: solid 1px #028C4A; color: #028C4A"
                >
                  Entrega de documentos
                </button>

                <button
                  @click="abrirEntregaPasses()"
                  class="flex items-center justify-center form-submit py-2 ml-3 md:w-auto"
                >
                  Entrega de passes
                </button>

                <button
                  @click="abrirHistoricoPasses()"
                  class="flex items-center justify-center form-submit py-2 ml-3 md:w-auto"
                  style="background: #e2e8f0; border: solid 1px #028C4A; color: #028C4A"
                >
                  Histórico de passes
                </button>
              </div>
            </div>
          </div>
        </template>

        <div
          class="flex justify-between w-full mb-8 border-b-2 border-green-base bg-white shadow-lg"
        >
          <span class="mt-2 text-base uppercase text-green-base">
            Informações Pessoais
          </span>
          <button
            v-if="!getBeneficiarioLoading && !isBeneficiarioEdit"
            @click="onEditBeneficiarioClick"
            class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-base"
          >
            <div class="flex text-green-base items-center justify-center">
              Editar
            </div>
          </button>
          <div
            v-if="!getBeneficiarioLoading && isBeneficiarioEdit"
            class="flex gap-3"
          >
            <button
              @click="cancelEditBeneficiario"
              class="px-2 py-2 mb-2 form-new-green sm:py-1 border-red-400"
            >
              <div class="flex text-red-400 items-center justify-center">
                Cancelar
              </div>
            </button>
            <button
              @click.prevent="$refs.modal.showModal()"
              class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-500"
            >
              <div class="flex text-green-500 items-center justify-center">
                Salvar
              </div>
            </button>
          </div>
        </div>

        <template v-if="getBeneficiarioLoading">
          <div class="px-4">Carregando...</div>
        </template>
        <template v-else>
          <div class="grid gap-5 grid-cols-12 grid-rows-3  px-3">
            <div class="row-span-3 col-span-2">
              <label class="upload-area">
                <span v-if="!imagePreview">
                  {{ isBeneficiarioEdit ? 'Adicione uma foto' : 'Sem foto' }}
                </span>
                <img v-if="imagePreview" :src="imagePreview" alt="Preview">
                <input
                  v-if="isBeneficiarioEdit"
                  type="file"
                  accept="image/*"
                  @change="handleImage"
                >
              </label>
            </div>
            <div class="col-span-2">
              <span class="text-sm form-label text-gray-dark"> CPF </span>
              <div v-if="isBeneficiarioEdit">
                <TheMask
                  v-model="beneficiarioForm.document"
                  :mask="['###.###.###-##']"
                  type="text"
                  class="h-auto py-2 rounded form-input mb-0"
                  :class="{
                      'bg-red-100 border-red-400':
                      hasErrors &&
                      !beneficiarioForm.document
                  }"
                />
                <div
                  v-if="hasErrors && !beneficiarioForm.document"
                  class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                >
                  Campo obrigatório
                </div>
              </div>
              <div v-else>{{ beneficiario.document }}</div>
            </div>
            <div class="col-span-4">
              <span class="text-sm form-label text-gray-dark"> Nome </span>

              <div v-if="isBeneficiarioEdit">
                <input
                  v-model="beneficiarioForm.nmnome"
                  type="text"
                  class="h-auto py-2 rounded form-input mb-0"
                  :class="{
                    'bg-red-100 border-red-400':
                    hasErrors &&
                    !beneficiarioForm.nmnome
                  }"
                >
                <div
                  v-if="hasErrors && !beneficiarioForm.nmnome"
                  class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                >
                  Campo obrigatório
                </div>
              </div>
              <div v-else>{{ beneficiario.nmnome }}</div>
            </div>
            <div class="col-span-3">
              <span class="text-sm form-label text-gray-dark">
                Data de nascimento
              </span>
              <div v-if="isBeneficiarioEdit">
                <input
                  v-model="beneficiarioForm.dtnascimento"
                  type="text"
                  class="h-auto py-2 rounded form-input"
                  :class="{
                    'bg-red-100 border-red-400':
                    hasErrors &&
                    (!beneficiarioForm.dtnascimento ||
                    !validBirthDate)
                  }"
                  required
                  @input="$event =>
                    validateBirthDateOnInput($event.target.value)"
                >
                <div
                  v-if="!validBirthDate ||
                    beneficiarioForm.dtnascimento.length === 8"
                  class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                >
                  Data inválida
                </div>

                <div
                  v-if="hasErrors && !beneficiarioForm.dtnascimento"
                  class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                >
                  Campo obrigatório
                </div>
              </div>
              <div v-else>{{ beneficiario.dtnascimento }}</div>
            </div>
            <div class="col-span-2">
              <span class="text-sm form-label text-gray-dark"> Matrícula </span>
              <div>{{ id }}</div>
            </div>
            <div class="col-span-3">
              <span class="text-sm form-label text-gray-dark">
                Tipo de beneficiário
              </span>
              <div class="" v-if="isBeneficiarioEdit">
                <Select
                  :key="beneficiario.tpbeneficiario"
                  id="status"
                  class="w-full"
                  selectClass="w-full form-select filter-select "
                  :options="tiposBeneficiario"
                  :selected.sync="beneficiario.tpbeneficiario"
                  @changed="tipoBeneficiariosSelected"
                />
                <div
                  v-if="hasErrors &&
                    beneficiario.tpbeneficiario == 0"
                  class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                >
                  Campo obrigatório
                </div>
              </div>

              <div v-else>
                {{getBeneficiarioType(beneficiario.tpbeneficiario)}}
              </div>
            </div>
            <div class="col-span-2">
              <span class="text-sm form-label text-gray-dark"> CEP </span>
              <div v-if="isBeneficiarioEdit">
                <TheMask
                  v-model="beneficiarioForm.cep"
                  :mask="['##.###-###']"
                  class="h-auto py-2 rounded form-input mb-0"
                  :class="{
                    'bg-red-100 border-red-400':
                    hasErrors && !beneficiarioForm.cep
                  }"
                  @input="onCepChangeBeneficiario"
                  required
                />
                <div
                  v-if="hasErrors && !beneficiarioForm.cep"
                  class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                >
                  Campo obrigatório
                </div>
              </div>
              <div v-else>{{ mask(beneficiario.cep, "#####-###") }}</div>
            </div>
            <div class="col-span-2">
              <span class="text-sm form-label text-gray-dark"> Endereço </span>
              <div v-if="isBeneficiarioEdit">
                <input
                  v-model="beneficiarioForm.street"
                  type="text"
                  class="h-auto py-2 rounded form-input mb-0"
                  :class="{
                    'bg-red-100 border-red-400':
                    hasErrors &&
                    !beneficiarioForm.street
                  }"
                >
                <div
                  v-if="hasErrors && !beneficiarioForm.street"
                  class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                >
                  Campo obrigatório
                </div>
              </div>
              <div v-else>{{ beneficiario.street }}</div>
            </div>
            <div class="col-span-1">
              <span class="text-sm form-label text-gray-dark"> Número </span>
              <div v-if="isBeneficiarioEdit">
                <input
                  v-model="beneficiarioForm.number"
                  type="number"
                  class="h-auto py-2 rounded form-input mb-0"
                >
              </div>
              <div v-else>{{ beneficiario.number }}</div>
            </div>
            <div class="col-span-2">
              <span class="text-sm form-label text-gray-dark"> Bairro </span>
              <div v-if="isBeneficiarioEdit">
                <input
                  v-model="beneficiarioForm.district"
                  type="text"
                  class="h-auto py-2 rounded form-input mb-0"
                  :class="{
                    'bg-red-100 border-red-400':
                    hasErrors &&
                    !beneficiarioForm.district
                  }"
                >
                <div
                  v-if="hasErrors && !beneficiarioForm.district"
                  class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                >
                  Campo obrigatório
                </div>
              </div>
              <div v-else>{{ beneficiario.district }}</div>
            </div>
            <div class="col-span-2">
              <span class="text-sm form-label text-gray-dark">
                Complemento
              </span>
              <div v-if="isBeneficiarioEdit">
                <input
                  v-model="beneficiarioForm.complement"
                  type="text"
                  class="h-auto py-2 rounded form-input mb-0"
                >
              </div>
              <div v-else>{{ beneficiario.complement }}</div>
            </div>
            <div class="col-span-2">
              <span class="text-sm form-label text-gray-dark">
                Cidade/estado
              </span>
              <div v-if="isBeneficiarioEdit">
                <search-select
                  :selected.sync="beneficiarioForm.numunicipio"
                  :search-keys="['name']"
                  :search-remote="true"
                  :lazy-load="true"
                  options-url="/api/registry/location?take=50&paginate=false"
                  option-key="id"
                  :option-value="city =>
                    `${city.name} / ${city.state.initials}`"
                  field-class="py-2"
                  name="city"
                  placeholder="Selecione uma cidade..."
                  @changed="cityBeneficiarioSelected"
                />
              </div>
              <div v-else>
                {{
                  beneficiario.numunicipio
                  ? `${beneficiario.numunicipio.name} / ${beneficiario.numunicipio.state.initials}`
                  : ""
                }}
              </div>
            </div>
          </div>

          <div
            class="flex justify-between w-full mb-8 border-b-2 border-green-base bg-white shadow-lg"
          >
            <span class="mt-2 text-base uppercase text-green-base">
              Contato
            </span>
            <button
              v-if="!getBeneficiarioLoading && !isContatoEdit"
              @click="onEditBeneficiarioClick('contatos')"
              class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-base"
            >
              <div class="flex text-green-base items-center justify-center">
                Editar
              </div>
            </button>
            <div
              v-if="!getBeneficiarioLoading && isContatoEdit"
              class="flex gap-3"
            >
              <button
                @click="cancelEditContato"
                class="px-2 py-2 mb-2 form-new-green sm:py-1 border-red-400"
              >
                <div class="flex text-red-400 items-center justify-center">
                  Cancelar
                </div>
              </button>
              <button
                @click.prevent="$refs.modal.showModal()"
                class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-500"
              >
                <div class="flex text-green-500 items-center justify-center">
                  Salvar
                </div>
              </button>
            </div>
          </div>
          <ContactsList
            :emails="beneficiario.contatos.emails"
            :phones="beneficiario.contatos.phones"
            :emailsForm="contatosBeneficiarioForm.emails"
            :phonesForm="contatosBeneficiarioForm.phones"
            :readonly="!isContatoEdit"
          ></ContactsList>

          <div v-for="(filiacao, index) in beneficiario.filiacao" :key="index">
            <div
              class="flex justify-between w-full mb-8 border-b-2 border-green-base bg-white shadow-lg"
            >
              <span class="mt-2 text-base uppercase text-green-base">
                Filiação
              </span>

              <button
                v-if="!getBeneficiarioLoading &&
                  !isFiliacaoEdit[index]"
                @click="onEditBeneficiarioClick('filiacao', index)"
                class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-base"
              >
                <div class="flex text-green-base items-center justify-center">
                  Editar
                </div>
              </button>
              <div
                v-if="!getBeneficiarioLoading &&
                  isFiliacaoEdit[index]"
                class="flex gap-3"
              >
                <button
                  @click="cancelEditFiliacao(index)"
                  class="px-2 py-2 mb-2 form-new-green sm:py-1 border-red-400"
                >
                  <div class="flex text-red-400 items-center justify-center">
                    Cancelar
                  </div>
                </button>
                <button
                  @click.prevent="$refs.modal.showModal()"
                  class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-500"
                >
                  <div class="flex text-green-500 items-center justify-center">
                    Salvar
                  </div>
                </button>
              </div>
            </div>
            <div class="grid gap-5 grid-cols-1 md:grid-cols-12  px-3">
              <div class="col-span-3">
                <span class="text-sm form-label text-gray-dark">
                  CPF {{ hasAdditionalConditions ? "*" : "" }}
                </span>
                <div v-if="isFiliacaoEdit[index]">
                  <TheMask
                    v-model="beneficiarioForm.filiacao[index].document"
                    :mask="['###.###.###-##']"
                    type="text"
                    @input="onCpfChangeFiliacao(index, $event)"
                    class="h-auto py-2 rounded form-input mb-0"
                    :class="{
                      'bg-red-100 border-red-400':
                      hasErrors &&
                      !beneficiarioForm.filiacao[index].document &&
                      beneficiarioForm.filiacao[index].cep
                    }"
                  />

                  <div
                    v-if="
                      hasErrors &&
                      !beneficiarioForm.filiacao[index].document &&
                      beneficiarioForm.filiacao[index].cep
                    "
                    class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                  >
                    Campo obrigatório
                  </div>
                </div>
                <span v-else>
                  {{mask(filiacao.document,"###.###.###-##")}}
                </span>
              </div>
              <div class="col-span-6">
                <span class="text-sm form-label text-gray-dark"> Nome </span>
                <div v-if="isFiliacaoEdit[index]">
                  <input
                    v-model="beneficiarioForm.filiacao[index].nmnome"
                    type="text"
                    class="h-auto py-2 rounded form-input mb-0"
                    :class="{
                      'bg-red-100 border-red-400':hasErrors &&
                      !beneficiarioForm.filiacao[index].nmnome
                    }"
                  >
                  <div
                    v-if="hasErrors &&
                      !beneficiarioForm.filiacao[index].nmnome"
                    class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                  >
                    Campo obrigatório
                  </div>
                </div>
                <span v-else> {{ filiacao.nmnome }}</span>
              </div>
              <div class="col-span-3">
                <span class="text-sm form-label text-gray-dark">
                  Parentesco
                </span>
                <div v-if="isFiliacaoEdit[index]">
                  <Select
                    :key="beneficiarioForm.filiacao[index].tpparentesco"
                    id="status"
                    :class="{
                      'w-full bg-red-100 border-red-400':
                      (hasErrors &&
                      !beneficiarioForm.filiacao[index].nmnome) ||
                      ((beneficiarioForm.filiacao[index].document == undefined ||
                      beneficiarioForm.filiacao[index].document == '') &&
                      beneficiarioForm.filiacao[index].cep != undefined &&
                      beneficiarioForm.filiacao[index].cep != '')
                    }"
                    selectClass="w-full form-select filter-select "
                    :options="filiacaoOptions"
                    :selected.sync="beneficiarioForm.filiacao[index].tpparentesco"
                  />
                  <div
                    v-if="
                      (hasErrors &&
                      !beneficiarioForm.filiacao[index].tpparentesco) ||
                      ((beneficiarioForm.filiacao[index].document == undefined ||
                      beneficiarioForm.filiacao[index].document == '') &&
                      beneficiarioForm.filiacao[index].cep != undefined &&
                      beneficiarioForm.filiacao[index].cep != '')
                    "
                    class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                  >
                    Campo obrigatório
                  </div>
                </div>
                <span v-else> {{ getParentesco(filiacao.tpparentesco) }}</span>
              </div>
              <div class="col-span-3">
                <span class="text-sm form-label text-gray-dark"> CEP </span>

                <div v-if="isFiliacaoEdit[index]">
                  <TheMask
                    v-model="beneficiarioForm.filiacao[index].cep"
                    :mask="['##.###-###']"
                    class="h-auto py-2 rounded form-input mb-0"
                    :class="{
                      'bg-red-100 border-red-400':
                      hasErrors &&
                      beneficiarioForm.filiacao[index].document &&
                      !beneficiarioForm.filiacao[index].cep
                    }"
                    @input="onCepChangeFiliacao(index, $event)"
                    required
                  />

                  <div
                    v-if="
                      hasErrors &&
                      beneficiarioForm.filiacao[index].document &&
                      !beneficiarioForm.filiacao[index].cep
                    "
                    class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                  >
                    Campo obrigatório
                  </div>
                </div>
                <div v-else>
                  {{
                    filiacao.cep
                    ? mask(filiacao.cep, "#####-###")
                    : ""
                  }}
                </div>
              </div>
              <div class="col-span-6">
                <span class="text-sm form-label text-gray-dark">
                  Endereço
                </span>
                <div v-if="isFiliacaoEdit[index]">
                  <input
                    v-model="beneficiarioForm.filiacao[index].street"
                    disabled
                    type="text"
                    class="h-auto py-2 rounded form-input mb-0"
                  >
                </div>
                <div v-else>{{ filiacao.street }}</div>
              </div>
              <div class="col-span-1">
                <span class="text-sm form-label text-gray-dark"> Número </span>
                <div v-if="isFiliacaoEdit[index]">
                  <input
                    v-model="beneficiarioForm.filiacao[index].number"
                    type="number"
                    class="h-auto py-2 rounded form-input mb-0"
                  >
                </div>
                <div v-else>{{ filiacao.number }}</div>
              </div>
              <div class="col-span-2">
                <span class="text-sm form-label text-gray-dark"> Bairro </span>
                <div v-if="isFiliacaoEdit[index]">
                  <input
                    v-model="beneficiarioForm.filiacao[index].district"
                    type="text"
                    class="h-auto py-2 rounded form-input mb-0"
                    disabled
                    :class="{
                        'bg-red-100 border-red-400':
                        (isNullOrEmpty(beneficiarioForm.filiacao[index].district) &&
                        beneficiarioForm.filiacao[index].contatos.emails.length > 0 &&
                        beneficiarioForm.filiacao[index].contatos.emails[0].contact !== '' &&
                        isNullOrEmpty(beneficiarioForm.filiacao[index].contatos.emails[0].id)) ||
                        (isNullOrEmpty(beneficiarioForm.filiacao[index].district) &&
                        beneficiarioForm.filiacao[index].contatos.phones.length > 0 &&
                        beneficiarioForm.filiacao[index].contatos.phones[0].contact !== '' &&
                        isNullOrEmpty(beneficiarioForm.filiacao[index].contatos.phones[0].id))
                    }"
                  >
                  <div
                    v-if="
                      (isNullOrEmpty(beneficiarioForm.filiacao[index].district) &&
                      beneficiarioForm.filiacao[index].contatos.emails.length > 0 &&
                      beneficiarioForm.filiacao[index].contatos.emails[0].contact !== '' &&
                      isNullOrEmpty(beneficiarioForm.filiacao[index].contatos.emails[0].id)) ||
                      (isNullOrEmpty(beneficiarioForm.filiacao[index].district) &&
                      beneficiarioForm.filiacao[index].contatos.phones.length > 0 &&
                      beneficiarioForm.filiacao[index].contatos.phones[0].contact !== '' &&
                      isNullOrEmpty(beneficiarioForm.filiacao[index].contatos.phones[0].id))
                    "
                    class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                  >
                    Campo obrigatório
                  </div>
                </div>
                <div v-else>{{ filiacao.district }}</div>
              </div>
              <div class="col-span-3">
                <span class="text-sm form-label text-gray-dark">
                  Complemento
                </span>
                <div v-if="isFiliacaoEdit[index]">
                  <input
                    v-model="beneficiarioForm.filiacao[index].complement"
                    type="text"
                    class="h-auto py-2 rounded form-input mb-0"
                  >
                </div>
                <div v-else>{{ filiacao.complement }}</div>
              </div>
              <div class="col-span-6 ">
                <span class="text-sm form-label text-gray-dark">
                  Cidade/estado
                </span>
                <div v-if="isFiliacaoEdit[index]">
                  <search-select
                    :selected.sync="beneficiarioForm.filiacao[index].city"
                    :search-keys="['name']"
                    :search-remote="true"
                    :lazy-load="true"
                    disabled
                    options-url="/api/registry/location?take=50&paginate=false"
                    option-key="id"
                    :option-value="city =>
                      `${city.name} / ${city.state.initials}`"
                    field-class="py-2"
                    name="city"
                    placeholder="Selecione uma cidade..."
                    @changed="cityFiliacaoSelected"
                  />

                  <div
                    v-if="
                      (isNullOrEmpty(beneficiarioForm.filiacao[index].city) &&
                      beneficiarioForm.filiacao[index].contatos.emails.length > 0 &&
                      beneficiarioForm.filiacao[index].contatos.emails[0].contact !== '' &&
                      isNullOrEmpty(beneficiarioForm.filiacao[index].contatos.emails[0].id)) ||
                      (isNullOrEmpty(beneficiarioForm.filiacao[index].city) &&
                      beneficiarioForm.filiacao[index].contatos.phones.length > 0 &&
                      beneficiarioForm.filiacao[index].contatos.phones[0].contact !== '' &&
                      isNullOrEmpty(beneficiarioForm.filiacao[index].contatos.phones[0].id))
                    "
                    class="alert alert-danger text-red-500 text-xs mr-2 font-bold"
                  >
                    Campo obrigatório
                  </div>
                </div>
                <div v-else>
                  {{
                    filiacao.city
                    ? `${filiacao.city.name} / ${filiacao.city.state.name}`
                    : ""
                  }}
                </div>
              </div>
            </div>

            <div
              class="flex justify-between w-full mb-8 mt-4 border-b-2 border-green-base bg-white shadow-lg"
            >
              <span class="mt-2 text-base uppercase text-green-base">
                Contato da filiação
              </span>
              <button
                v-if="!getBeneficiarioLoading &&
                  !isFiliacaoContatoEdit"
                @click="onEditBeneficiarioFiliacaoClick(index)"
                class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-base"
              >
                <div class="flex text-green-base items-center justify-center">
                  Editar
                </div>
              </button>
              <div
                v-if="!getBeneficiarioLoading &&
                  isFiliacaoContatoEdit"
                class="flex gap-3"
              >
                <button
                  @click="cancelEditFiliacaoContato"
                  class="px-2 py-2 mb-2 form-new-green sm:py-1 border-red-400"
                >
                  <div class="flex text-red-400 items-center justify-center">
                    Cancelar
                  </div>
                </button>
                <button
                  @click.prevent="$refs.modal.showModal()"
                  class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-500"
                >
                  <div class="flex text-green-500 items-center justify-center">
                    Salvar
                  </div>
                </button>
              </div>
            </div>
            <ContactsList
              :emails="filiacao.contatos.emails"
              :phones="filiacao.contatos.phones"
              :emailsForm="beneficiarioForm.filiacao[index].contatos.emails"
              :phonesForm="beneficiarioForm.filiacao[index].contatos.phones"
              :readonly="!isFiliacaoContatoEdit"
            ></ContactsList>
          </div>
          <a href="#" id="ac"></a>
          <template
            v-if="this.beneficiarioForm &&
              Number(this.beneficiario.tpbeneficiario) === TipoBeneficiario.ESTUDANTE"
          >
            <EstudanteForm
              :beneficiarioEstudante="beneficiarioEstudante"
              :beneficiarioEstudanteForm="beneficiarioEstudanteForm"
              :readonly="!isTrabalhadorOuEstudanteEdit"
            >
              <button
                v-if="!getBeneficiarioLoading &&
                  !isTrabalhadorOuEstudanteEdit"
                @click="onEditBeneficiarioClick('trabalhadorOuEstudante')"
                class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-base"
              >
                <div class="flex text-green-base items-center justify-center">
                  Editar
                </div>
              </button>
              <div
                v-if="!getBeneficiarioLoading &&
                  isTrabalhadorOuEstudanteEdit"
                class="flex gap-3"
              >
                <button
                  @click="cancelEditTrabalhadorOuEstudante()"
                  class="px-2 py-2 mb-2 form-new-green sm:py-1 border-red-400"
                >
                  <div class="flex text-red-400 items-center justify-center">
                    Cancelar
                  </div>
                </button>
                <button
                  @click.prevent="$refs.modal.showModal()"
                  class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-500"
                >
                  <div class="flex text-green-500 items-center justify-center">
                    Salvar
                  </div>
                </button>
              </div>
            </EstudanteForm>
          </template>
          <template
            v-if="this.beneficiarioForm &&
              Number(this.beneficiario.tpbeneficiario) === TipoBeneficiario.ESTAGIARIO"
          >
            <EstagiarioForm
              :beneficiarioEstagiario="beneficiarioEstagiario"
              :beneficiarioEstagiarioForm="beneficiarioEstagiarioForm"
              :readonly="!isTrabalhadorOuEstudanteEdit"
            >
              <button
                v-if="!getBeneficiarioLoading &&
                  !isTrabalhadorOuEstudanteEdit"
                @click="onEditBeneficiarioClick('trabalhadorOuEstudante')"
                class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-base"
              >
                <div class="flex text-green-base items-center justify-center">
                  Editar
                </div>
              </button>
              <div
                v-if="!getBeneficiarioLoading &&
                  isTrabalhadorOuEstudanteEdit"
                class="flex gap-3"
              >
                <button
                  @click="cancelEditTrabalhadorOuEstudante()"
                  class="px-2 py-2 mb-2 form-new-green sm:py-1 border-red-400"
                >
                  <div class="flex text-red-400 items-center justify-center">
                    Cancelar
                  </div>
                </button>
                <button
                  @click.prevent="$refs.modal.showModal()"
                  class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-500"
                >
                  <div class="flex text-green-500 items-center justify-center">
                    Salvar
                  </div>
                </button>
              </div>
            </EstagiarioForm>
          </template>
          <template
            v-if="this.beneficiarioForm &&
              Number(this.beneficiario.tpbeneficiario) === TipoBeneficiario.TRABALHADOR"
          >
            <TrabalhadorForm
              :beneficiarioTrabalhador="beneficiarioTrabalhador"
              :beneficiarioTrabalhadorForm="beneficiarioTrabalhadorForm"
              :readonly="!isTrabalhadorOuEstudanteEdit"
            >
              <button
                v-if="!getBeneficiarioLoading &&
                  !isTrabalhadorOuEstudanteEdit"
                @click="onEditBeneficiarioClick('trabalhadorOuEstudante')"
                class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-base"
              >
                <div class="flex text-green-base items-center justify-center">
                  Editar
                </div>
              </button>
              <div
                v-if="!getBeneficiarioLoading &&
                  isTrabalhadorOuEstudanteEdit"
                class="flex gap-3"
              >
                <button
                  @click="cancelEditTrabalhadorOuEstudante()"
                  class="px-2 py-2 mb-2 form-new-green sm:py-1 border-red-400"
                >
                  <div class="flex text-red-400 items-center justify-center">
                    Cancelar
                  </div>
                </button>
                <button
                  @click.prevent="$refs.modal.showModal()"
                  class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-500"
                >
                  <div class="flex text-green-500 items-center justify-center">
                    Salvar
                  </div>
                </button>
              </div>
            </TrabalhadorForm>
          </template>
          <div
            class="flex justify-between w-full mb-8 border-b-2 border-green-base bg-white shadow-lg"
          >
            <span class="mt-2 text-base uppercase text-green-base">
              Contato da instituição
            </span>
            <button
              v-if="!getBeneficiarioLoading &&
                !isContatoInstituicaoEdit"
              @click="onEditBeneficiarioClick('contatoInstituicaoEdit')"
              class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-base"
            >
              <div class="flex text-green-base items-center justify-center">
                Editar
              </div>
            </button>
            <div
              v-if="!getBeneficiarioLoading &&
                isContatoInstituicaoEdit"
              class="flex gap-3"
            >
              <button
                @click="cancelEditContatoInstituicao()"
                class="px-2 py-2 mb-2 form-new-green sm:py-1 border-red-400"
              >
                <div class="flex text-red-400 items-center justify-center">
                  Cancelar
                </div>
              </button>
              <button
                @click.prevent="$refs.modal.showModal()"
                class="px-2 py-2 mb-2 form-new-green sm:py-1 border-green-500"
              >
                <div class="flex text-green-500 items-center justify-center">
                  Salvar
                </div>
              </button>
            </div>
          </div>
          <ContactsList
            :emails="contatosInsituicao.emails"
            :phones="contatosInsituicao.phones"
            :emailsForm="contatosInsituicaoForm.emails"
            :phonesForm="contatosInsituicaoForm.phones"
            :readonly="!isContatoInstituicaoEdit"
          ></ContactsList>
        </template>
      </div>
      <div
        class="mt-4 flex flex-col space-y-4 lg:items-center lg:flex-row lg:space-y-0 lg:space-x-4 justify-between"
      >
        <div
          class="flex flex-col space-y-4 lg:items-center lg:flex-row lg:space-y-0 lg:space-x-4"
        >
          <button
            @click="goBack()"
            type="button"
            class="flex items-center justify-center py-2 form-submit md:w-auto"
            style="background: #828282"
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
    <dialog ref="modal">
      <h3>Confirmar a edição do beneficiário?</h3>
      <div
        class="mt-4 flex items-center justify-center flex-col space-y-4 lg:items-center lg:flex-row lg:space-y-0 lg:space-x-4"
      >
        <button
          type="button"
          class="flex items-center justify-center py-2 form-submit md:w-auto"
          style="background: #828282"
          @click.prevent="$refs.modal.close()"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="flex items-center justify-center py-2 form-submit md:w-auto"
          @click.prevent="$refs.modal.close();
            saveBeneficiarioForm();"
        >
          Confirmar
        </button>
      </div>
    </dialog>
    <dialog
      ref="modalEntregaDocumentos"
      @close="onModalEntregaDocumentosClose()"
    >
      <h3>{{ modalEntregaDocumentosData.title }}</h3>
      <div
        class="mt-4 flex items-center justify-center flex-col space-y-4 lg:items-center lg:flex-row lg:space-y-0 lg:space-x-4"
      >
        <button
          type="button"
          class="flex items-center justify-center py-2 form-submit md:w-auto"
          style="background: #828282"
          @click.prevent="modalEntregaDocumentosData.action = null;
            $refs.modalEntregaDocumentos.close();"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="flex items-center justify-center py-2 form-submit md:w-auto"
          @click.prevent="$refs.modalEntregaDocumentos.close()"
        >
          Confirmar
        </button>
      </div>
    </dialog>
  </div>
</template>
<style scoped>
  dialog {
    border: 2px solid #1767b2;
    background: white;
    outline: none;
  }

  dialog::backdrop {
    background: #c0c0c080;
  }

  h3 {
    color: #1767b2;
    font-weight: 900;
    font-size: 30px;
    text-align: center;
  }

  .content-pendencia {
    background-color: #ffce9d;
    /* min-height: 100px; */
    width: 400px;
    border: solid 1px black;
  }

  .content-pendencia.expandido {
    width: 600px;
    top: 0px;
    left: 0px;
    z-index: 1000;
  }

  .content-pendencia .title span {
    text-decoration: underline;
  }

  .blur-content {
    filter: blur(2px);
    pointer-events: none;
  }
  .upload-area {
    width: 100%;
    height: 100%;
    border: 2px #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #888;
    font-family: sans-serif;
    position: relative;
    overflow: hidden;
    border-radius: 10px;
  }

  .upload-area img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 10px;
  }

  input[type="file"] {
    display: none;
  }
</style>
